"use client";

import React from "react";
import { GlobalStyles } from "@mui/material";

/**
 * Hides the help-chat launcher while it is rendered.
 *
 * Rendered by a sheet for as long as it is open. The launcher sits in the
 * bottom corner, which on a phone is exactly where a bottom sheet keeps its
 * main button, and it floats above any z-index the sheet could take. Nobody
 * needs the chat in the ten seconds it takes to pick a size; it is back the
 * moment the sheet closes.
 */
export default function HideChatWidget() {
  return (
    <GlobalStyles
      styles={{
        "#chat-widget-bubble, #chat-widget-branding, #chat-widget-proactive, #chat-widget-grabber": {
          display: "none !important",
        },
      }}
    />
  );
}
